import colours from '../style/base/colours.less';
export default colours;
